import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { TUtmMarksEntityReducer } from '../types';

export const initialState: TUtmMarksEntityReducer = {
  query: {},
  cookie: {},
};

export const utmMarksSlice = createSlice({
  name: 'utmMarks',
  initialState,
  reducers: {
    setUtmMarks: (state, { payload }: PayloadAction<TUtmMarksEntityReducer>) => {
      state.query = {
        ...payload.query,
      };
      state.cookie = {
        ...payload.cookie,
      };
    },
  },
});

export const { setUtmMarks } = utmMarksSlice.actions;
